import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { Tax } from './tax.model';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';
@Injectable()
export class TaxService extends AbstractEntityService {

    protected resourceUrl = 'api/taxes';
    private resourceSearchUrl = 'api/_search/taxes';
    protected resourceCountUrl = 'api/_search/count/taxes';

    constructor(protected http: HttpClient) {super(http); }

    create(tax: Tax): Observable<Tax> {
        let copy: Tax = Object.assign({}, tax);
        return this.http.post<Tax>(this.resourceUrl, copy).map((res: Tax) => {
            return res;
        });
    }

    update(tax: Tax): Observable<Tax> {
        let copy: Tax = Object.assign({}, tax);
        return this.http.put<Tax>(this.resourceUrl, copy).map((res: Tax) => {
            return res;
        });
    }

    find(id: number): Observable<Tax> {
        return this.http.get<Tax>(`${this.resourceUrl}/${id}`).map((res: Tax) => {
            return res;
        });
    }

    query(req?: any): Observable<HttpResponse<Tax[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Tax[]>>(this.resourceUrl, options)
            ;
    }

    search(req?: any): Observable<HttpResponse<Tax[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Tax[]>>(this.resourceSearchUrl, options);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/tax/tax.service.ts